import { keys } from "./auth-service-tools168.js";
import { camelToKebabCase } from "./auth-service-tools170.js";
import "react";
import "./auth-service-tools177.js";

function cssObjectToString(css) {
  return keys(css).reduce((acc, rule) => css[rule] !== void 0 ? `${acc}${camelToKebabCase(rule)}:${css[rule]};` : acc, "").trim();
}

export { cssObjectToString };